// @mui
import { ListItemButton, ListItemIcon, ListSubheader } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
// config
import { ICON, NAV } from '../../../config-global';

// ----------------------------------------------------------------------

export const StyledItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'caption' && prop !== 'locked',
})(({ active, disabled, locked, depth, caption, theme }) => {
  const isLight = theme.palette.mode === 'light';

  const subItem = depth !== 1;

  const activeStyle = {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    ...(!isLight && {
      color: theme.palette.primary.light,
    }),
  };

  const activeSubStyle = {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    fontWeight: theme.typography.fontWeightMedium,
    ...(!isLight && {
      color: theme.palette.primary.light,
    }),
  };

  return {
    position: 'relative',
    textTransform: 'capitalize',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    borderRadius: theme.shape.borderRadius,
    height: NAV.H_DASHBOARD_ITEM,
    // Sub item
    ...(subItem && {
      height: NAV.H_DASHBOARD_ITEM_SUB,
      paddingLeft: 25 * depth,
      ...(depth > 2 && {
        paddingLeft: 30 * depth,
      }),
      ...(caption && {
        height: NAV.H_DASHBOARD_ITEM,
      }),
    }),
    // Active item
    ...(active && {
      ...activeStyle,
      '&:hover': {
        ...activeStyle,
      },
    }),
    // Active sub item
    ...(subItem &&
      active && {
      ...activeSubStyle,
      '&:hover': {
        ...activeSubStyle,
      },
    }),
    // Disabled
    ...(disabled && {
      '&.Mui-disabled': {
        opacity: 0.64,
      },
    }),
    // Travado: o visual do disabled (opaco e sem resposta ao mouse) sem o
    // tabindex -1 que o disabled do MUI poe; o item continua na ordem de Tab.
    ...(locked && {
      opacity: 0.64,
      pointerEvents: 'none',
    }),
  };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled(ListItemIcon)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: ICON.NAV_ITEM,
  height: ICON.NAV_ITEM,
});

// ----------------------------------------------------------------------

export const StyledDotIcon = styled('span', {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active, theme }) => ({
  width: 12,
  height: 2,
  borderRadius: 0,
  backgroundColor: theme.palette.text.disabled,
  transition: theme.transitions.create(['background-color', 'width'], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(active && {
    width: 16,
    backgroundColor: theme.palette.primary.main,
  }),
}));

// ----------------------------------------------------------------------

export const StyledSubheader = styled(ListSubheader)(({ theme }) => ({
  ...theme.typography.overline,
  fontSize: 11,
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
}));